<div class="card">
  <p class="card__title" *ngIf="company">{{title}}</p>
  <ng-container *ngIf="viewSkeleton; else skeleton" [ngTemplateOutlet]="viewBillers"></ng-container>
</div>
<!-- Vista cuando llegan los billers -->
<ng-template #viewBillers>
  <app-basic-card [picture]="picture" type="navigation">
    <p class="card__select">{{ nameBiller }}</p>
  </app-basic-card>
</ng-template>

<!-- Muestra un skeleton mientras llegan los billers  -->
<ng-template #skeleton>
  <ngx-skeleton-loader
          count="1"
          appearance="circle"
          [theme]="{
          width: '70px',
          height: '70px',
          'border-radius': '100px',
          margin: 0
        }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
          count="1"
          [theme]="{ 'border-radius': '15px', height: '16px', width: '250px', margin: 0 }"
        ></ngx-skeleton-loader>
</ng-template>

